import React from 'react';
import { token } from '@atlaskit/tokens';
import type { Line } from './toPortInfo.tsx';
import { move, line } from './lineLeft.tsx';

interface Props {
	lines: Line[];
}

/**
 * Alignment lines that appear when dragging a status and allow aligning with other statuses
 */
const SnapLines = ({ lines }: Props): React.JSX.Element => (
	<>
		{lines.map(({ start, end }, i) => (
			<path
				key={i}
				fill="none"
				stroke={token('color.border.accent.orange')}
				d={move(start) + line(end)}
			/>
		))}
	</>
);

export default SnapLines;
